import { Check, Crown, Edit3 } from 'lucide-react'
import type { Pack } from '../../types/domain'
import { currency } from '../../lib/format'
import { Button } from '../ui/Button'

export function SponsorshipPackageCard({ pack, onSelect, editable = false }: { pack: Pack; onSelect?: (pack: Pack) => void; editable?: boolean }) {
  return <article className={`package-card ${pack.exclusive ? 'package-card--featured' : ''}`}>
    {pack.exclusive && <div className="package-card__feature"><Crown size={16} />Partenariat signature</div>}
    <div className="package-card__head"><div><h3>{pack.name}</h3><p>{pack.description}</p></div><strong>{currency(pack.price)}</strong></div>
    <div className="package-card__meta"><span>{pack.durationMonths} mois</span><span>{pack.slots} place{pack.slots > 1 ? 's' : ''}</span></div>
    <ul>{pack.deliverables.map((item) => <li key={item}><Check size={16} />{item}</li>)}</ul>
    <p className="package-card__rights"><strong>Droits à l’image :</strong> {pack.imageRights}</p>
    <Button variant={pack.exclusive ? 'action' : 'primary'} onClick={() => onSelect?.(pack)}>{editable ? <><Edit3 size={16} /> Modifier le pack</> : 'Choisir ce pack'}</Button>
  </article>
}
